import React from 'react';
import {ChevronRightIcon, HStack, Pressable} from 'native-base';
import {Semaphore} from '../../../../components/semaphore';
import {message as t} from '../../../../utils/messages';
import {ISemaphoreItem} from '../../../../interfaces/dtos';

interface Props extends ISemaphoreItem {
  position?: number;
  label?: string;
  onPress?: (position: number) => void;
}

const SemaphoreItem = (props: Props) => {
  const {onPress, label, position, ...item} = props;
  const {amount, value, color} = item;

  const handleOnPress = () => {
    if (onPress) {
      onPress(position ?? 0);
    }
  };

  return (
    <Pressable onPress={() => handleOnPress()}>
      <HStack paddingBottom="5" alignItems="center" space={2}>
        <Semaphore
          label={t(label ?? '')}
          amount={amount}
          value={value}
          color={color ?? '#0088FF'}
        />
        {onPress && <ChevronRightIcon color="#0088FF" size={6} />}
      </HStack>
    </Pressable>
  );
};

export default SemaphoreItem;
